import { useEffect, useRef, useState } from "react";
import { createMeetingAudioRecovery } from "./meetingAudioRecovery";
import { RECOVERY_STATUS, isMobileMeetingBrowser } from "./recoveryPlan";

export function useMeetingAudioRecovery({ jitsiDomain, onRejoin }) {
  const onRejoinRef = useRef(onRejoin);
  onRejoinRef.current = onRejoin;
  const controllerRef = useRef(null);
  const [snapshot, setSnapshot] = useState({
    status: RECOVERY_STATUS.CONNECTED,
    detail: "",
    gestureRequired: false,
    sessionId: "",
    conferenceJoined: false,
  });

  if (!controllerRef.current) {
    const domain = jitsiDomain || "";
    controllerRef.current = createMeetingAudioRecovery({
      isMobile: isMobileMeetingBrowser(
        typeof navigator !== "undefined" ? navigator.userAgent : "",
        typeof navigator !== "undefined" ? navigator.platform : "",
        typeof navigator !== "undefined" ? navigator.maxTouchPoints : 0
      ),
      jitsiDomain: domain,
      targetOrigin: domain ? `https://${domain}` : "*",
      onChange: setSnapshot,
      onRejoin: () => {
        if (typeof onRejoinRef.current === "function") onRejoinRef.current();
      },
    });
  }

  useEffect(() => {
    const controller = controllerRef.current;
    controller.start();
    return () => controller.detach();
  }, []);

  return {
    ...snapshot,
    attach: controllerRef.current.attach,
    restoreAudio: controllerRef.current.restoreAudio,
    rejoin: controllerRef.current.rejoin,
  };
}
